import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { countryValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import CountryForm from "./CountryForm";

const CreateCountry = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    clearErrors,
    getValues,
  } = useForm<any>({
    resolver: yupResolver(countryValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <CountryForm
        errors={errors}
        register={register}
        setValue={setValue}
        clearErrors={clearErrors}
        getValues={getValues}
      />
    </FormLayout>
  );
};

export default CreateCountry;
